import { captureStack1fzi4aczwc4hg as captureStack } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlinx_io_IOException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.h4i_1);
}
var IOExceptionClass;
function IOException() {
  if (IOExceptionClass === VOID) {
    class $ extends Exception() {
      static i4i() {
        var $this = this.td();
        init_kotlinx_io_IOException($this);
        return $this;
      }
      static j4i(message) {
        var $this = this.ud(message);
        init_kotlinx_io_IOException($this);
        return $this;
      }
      static k4i(message, cause) {
        var $this = this.vd(message, cause);
        init_kotlinx_io_IOException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IOException', $.i4i);
    IOExceptionClass = $;
  }
  return IOExceptionClass;
}
function init_kotlinx_io_EOFException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.n4f_1);
}
var EOFExceptionClass;
function EOFException() {
  if (EOFExceptionClass === VOID) {
    class $ extends IOException() {
      static l4i() {
        var $this = this.i4i();
        init_kotlinx_io_EOFException($this);
        return $this;
      }
      static o4f(message) {
        var $this = this.j4i(message);
        init_kotlinx_io_EOFException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'EOFException', $.l4i);
    EOFExceptionClass = $;
  }
  return EOFExceptionClass;
}
//region block: exports
export {
  EOFException as EOFExceptionh831u25jcq9n,
  IOException as IOException1wyutdmfe71nu,
};
//endregion

//# sourceMappingURL=-PlatformJs.mjs.map
